export default __webpack_public_path__ + "static/097-8591aebb93a0a77dc558249c105977f5.jpg";